export default __webpack_public_path__ + "static/media/Ballroll_00274.4e3dd7ff.png";